export const name = "INITCAP";
export const summary = `Formats a \`STRING\` as proper case, which means that the first character in each word is uppercase and all other characters are lowercase.`;
export const reference = `
## INITCAP

Formats a \`STRING\` as proper case, which means that the first character in each word is uppercase and all other characters are lowercase.

\`\`\`
INITCAP(value[, delimiters])
\`\`\`

### Description

Takes a \`STRING\` and returns it with the first character in each word in uppercase and all other characters in lowercase. Non-alphabetic characters remain the same.

\`delimiters\` is an optional string argument that's used to override the default set of characters used to separate words. If \`delimiters\` isn't specified, it defaults to the following characters:   
\`<whitespace> [] ( ) { } / | \\ < > ! ? @ " ^ # $ & ~ _ , . : ; * % + -\`

If \`value\` or \`delimiters\` is \`NULL\`, the function returns \`NULL\`.


### Return type

\`STRING\`


### Examples



\`\`\`
SELECT
  'Hello World-everyone!' AS value,
  INITCAP('Hello World-everyone!') AS initcap_value

/*-------------------------------+-------------------------------*
 | value | initcap_value |
 +-------------------------------+-------------------------------+
 | Hello World-everyone! | Hello World-Everyone! |
 *-------------------------------+-------------------------------*/
\`\`\`



\`\`\`
SELECT
  'Apples1oranges2pears' as value,
  '12' AS delimiters,
  INITCAP('Apples1oranges2pears' , '12') AS initcap_value

/*----------------------+------------+----------------------*
 | value | delimiters | initcap_value |
 +----------------------+------------+----------------------+
 | Apples1oranges2pears | 12 | Apples1Oranges2Pears |
 *----------------------+------------+----------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
